import { useQuery } from '@apollo/client';

import { JobsCountDocument } from './queries/jobs-count.query.gql-types';
import type { JobsCountQuery } from './queries/jobs-count.query.gql-types';

export function useJobsCount(): {
  loading: boolean;
  jobsCount?: JobsCountQuery;
} {
  const { loading, data } = useQuery(JobsCountDocument);

  return { loading, jobsCount: data };
}
